import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const AdminRoute = ({ children }) => {
  const { isAuthenticated, userLoading, user } = useSelector(
    (state) => state.auth
  );
  const location = useLocation();

  console.log('AdminRoute Hit →', location.pathname);
  console.log('User role:', user?.role);
  console.log('User role type:', typeof user?.role);
  console.log('Is array:', Array.isArray(user?.role));
  console.log('Is admin:', user?.role?.includes('admin'));

  useEffect(() => {
    if (userLoading) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto'; // Always clean up
    };
  }, [userLoading]);

  if (userLoading) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
          backgroundColor: 'white',
        }}
      >
        <div className='loader'></div>
      </div>
    );
  }

  if (!isAuthenticated && !userLoading) {
    return <Navigate to='/login' state={{ from: location.pathname }} replace />;
  }

  // Check if user has admin role
  // Ensure role is an array and contains 'admin'
  const hasAdminRole =
    Array.isArray(user?.role) && user?.role.includes('admin');

  if (!hasAdminRole) {
    console.log('Access denied: User does not have admin role');
    return <Navigate to='/unauthorized' replace />;
  }

  return children;
};

export default AdminRoute;
